<template>
  <div class="navigation">
    <div class="navigation-item" @click="goToPage(1, '选机构')">
      <h3>选机构</h3>
      <span>预约全国机构</span>
    </div>
    <div class="navigation-item" @click="goToPage(2, '找套餐')">
      <h3>找套餐</h3>
      <span>选购超值套餐</span>
    </div>
    <!-- <div v-if="!isWxMiniProgram" class="navigation-item" @click="goToPage(3, '查订单')"> -->
      <div class="navigation-item" @click="goToPage(3, '查订单')">
      <h3>查订单</h3>
      <span>快速查询订单</span>
    </div>
    <!-- <div v-else class="navigation-item" @click="goToPage(4, '核酸检测')">
      <h3>核酸检测</h3>
      <span>快速预约核酸</span>
    </div> -->
  </div>
</template>

<script>
import { isMiniProgram, toNucleicAcid } from '@/assets/js/util.js'
export default {
  name: "Navigation",
  computed: {
    isWxMiniProgram() {
      return isMiniProgram()
    }
  },
  methods: {
    goToPage(id, name) {
      this.$baiDuMtaEvent(["个检/首页", `点击${name}`, "", "-"]); //数据上报
      switch (id) {
        case 1:
          this.$router.push({
            path: "package-org-list",
            query: { type: "org" },
          });
          break;
        case 2:
          this.$router.push({
            path: "package-org-list",
            query: { type: "package" },
          });
          break;
        case 3:
          this.$router.push({ path: "order-list", query: { order_type: 1 } });
          break;
        case 4:
          toNucleicAcid(`${ZTPREFIX}?channel=006_88_1111_0002_00`)
          break
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 24/200rem;
  padding: 0 26/200rem 28/200rem 24/200rem;
  .navigation-item {
    width: 220/200rem;
    height: 192/200rem;
    background: #e0ecf4;
    border-radius: 6/200rem;
    font-family: PingFangSC-Regular, PingFang SC;
    text-indent: 20/200rem;
    h3 {
      margin: 24/200rem 0 12/200rem;
      font-size: 32/200rem;
      font-weight: 500;
      color: #404040;
      line-height: 32/200rem;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    span {
      font-size: 22/200rem;
      color: #85898c;
      line-height: 22/200rem;
    }
  }
  .navigation-item:nth-child(1) {
    background: url("~@/assets/images/home/icon_home_hospital_nor@2x.png")
      #e0ecf4 bottom / 128/200rem 80/200rem no-repeat;
  }
  .navigation-item:nth-child(2) {
    background: url("~@/assets/images/home/icon_home_taocan_nor@2x.png") #fcf0d8
      bottom / 160/200rem 80/200rem no-repeat;
  }
  .navigation-item:nth-child(3) {
    background: url("~@/assets/images/home/icon_home_order_nor@2x.png") #d9f5ed
      bottom / 124/200rem 80/200rem no-repeat;
  }
}
</style>
